module.exports = __webpack_public_path__ + "static/media/work-special-icon.b92cfa89.svg";